import React from "react";
import {connect} from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChildRenderer from "../../../../common_components/child_renderer";
import {isInitialised} from "../../../../utils/uninitialised";
import Permissioner from "../../../../utils/permissioner";
import DataAssetsTabs from "../components/data_assets_tabs";
import {User} from "common/types/user";
import {Workflow} from "common/flowmaster/types/workflow";

interface DataAssetsBaseContainerProps {
  user: User;
  location: {
    pathname: string;
  };
  definitions: Workflow[];
}

const DataAssetsBaseContainer: React.FC<DataAssetsBaseContainerProps> = props => {
  const {user, location, definitions} = props;

  const shouldRenderContainer = isInitialised([user, definitions]);

  if (!shouldRenderContainer || !user.permissions) {
    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  const permissioner = new Permissioner(user);
  if (
    !(permissioner.hasPermission("view-data-assets") || permissioner.isAdmin())
  ) {
    return permissioner.getNoPermissionMessage();
  }

  return (
    <div>
      <DataAssetsTabs currentPath={location.pathname} />
      <ChildRenderer {...props} />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.user,
    definitions: state.workflows,
  };
}

export default connect(mapStateToProps)(DataAssetsBaseContainer);
